import { render, staticRenderFns } from "./PlayNotifications.vue?vue&type=template&id=747e9b16&"
import script from "./PlayNotifications.vue?vue&type=script&lang=js&"
export * from "./PlayNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports